/**
 * Maps a quote status from the REST layer to the SPA's status key (#1498).
 * REST serializes the QuoteStatus enum by name ("FinalCheck", "PendingApproval"), while the
 * SPA keys statuses the GraphQL way ("FINAL_CHECK", "PENDING_APPROVAL"). A value that already
 * has an underscore or is all upper case is returned unchanged; null/undefined become "".
 */
export function quoteStatusKey(status: string | null | undefined): string {
	if (!status) return "";
	if (status.includes("_") || status === status.toUpperCase()) return status;
	return status.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toUpperCase();
}
